import { defineComponent as _defineComponent } from 'vue'
import { useContext, onMounted, onUnmounted } from '@nuxtjs/composition-api';
import { computed, ref } from 'vue';
import { IProject } from '~/types/project';
import { IEpisode } from '~/types/series';


export default /*#__PURE__*/_defineComponent({
  __name: 'NextEpisodeAutoplay',
  props: {
    nextEpisode: null
  },
  emits: ['play-next-episode', 'more-details-clicked'],
  setup(__props: any, { emit }) {

const props = __props as {
  nextEpisode?: IEpisode;
};

const NEXT_EPISODE_COUNTDOWN_SECONDS = 15;





const { $sanityImage, store, $ua } = useContext();

const countdownTime = ref(NEXT_EPISODE_COUNTDOWN_SECONDS);

const playIcon = require('@/assets/icons/play-icon-no-circle.svg');

const nextEpisodeProject = computed<IProject>(() =>
  store.getters['projects/getProjectBySlug'](props.nextEpisode?.projectSlug),
);

const projectLogoUrl = computed(() => {
  if (!nextEpisodeProject?.value?.logo) {
    return;
  }
  return $sanityImage.urlFor(nextEpisodeProject.value.logo).url();
});

const heroImageStyle = computed(() => {
  if (!props?.nextEpisode?.heroImage) {
    return '';
  }

  return `background: linear-gradient(180deg, rgba(18, 18, 18, 0.6) 0%, rgba(18, 18, 18, 0) 59.43%), linear-gradient(32deg, rgba(24, 24, 24, 0.6) 46.75%, rgba(24, 24, 24, 0) 85.24%), url(${props.nextEpisode.heroImage}) lightgray 50% / cover no-repeat;`;
});

let countdownTimer: any;

onMounted(() => {
  countdownTimer = setInterval(() => {
    if (countdownTime.value > 0) {
      countdownTime.value--;
    } else {
      playNextEpisode();
      clearInterval(countdownTimer);
    }
  }, 1000);
});

onUnmounted(() => {
  clearInterval(countdownTimer);
});

function playNextEpisodeClicked() {
  $ua.trackPress({
    interactionTargetId: 'next-episode-modal-play-button',
    context: props.nextEpisode?.slug,
  });
  playNextEpisode();
}

function moreDetailsClicked() {
  $ua.trackPress({
    interactionTargetId: 'next-episode-modal-more-details-button',
    context: props.nextEpisode?.slug,
  });
  emit('more-details-clicked');
}

function playNextEpisode() {
  emit('play-next-episode');
}

return { __sfc: true,NEXT_EPISODE_COUNTDOWN_SECONDS, props, emit, $sanityImage, store, $ua, countdownTime, playIcon, nextEpisodeProject, projectLogoUrl, heroImageStyle, countdownTimer, playNextEpisodeClicked, moreDetailsClicked, playNextEpisode }
}

})